import { gql } from '@lcs/shared/api';

export const clearQueueHistory = gql`
   mutation ClearQueueHistory($queueHistory: QueueHistoryInput!) {
      queueHistory: saveQueueHistory(queueHistory: $queueHistory) {
         queueHistoryId
         callDispositionId
         callCompleteDateTime
      }
   }
`;
